'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notificationPropLevel = _propTypes2.default.oneOf(['error', 'information']);

exports.default = notificationPropLevel;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Notification/notificationPropLevel.js
// module id = 621
// module chunks = 11